import { useLocation } from 'react-router';
import {
  Container, Alert,
} from '@openedx/paragon';
import { ErrorPage } from '@edx/frontend-platform/react';
import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';

import { Loading, Head } from '@src/generic';
import CourseAboutIntroSlot from '@src/plugin-slots/CourseAboutIntroSlot';
import CourseAboutCourseMediaSlot from '@src/plugin-slots/CourseAboutCourseMediaSlot';
import CourseAboutOverviewSlot from '@src/plugin-slots/CourseAboutOverviewSlot';
import CourseAboutSidebarSlot from '@src/plugin-slots/CourseAboutSidebarSlot';
import { useCourseAboutData } from './data/hooks';
import messages from './messages';

const CourseAboutPage = () => {
  const intl = useIntl();
  const courseId = useLocation().pathname.split('/')[2];
  const {
    data: courseAboutData,
    isLoading,
    isError,
  } = useCourseAboutData(courseId);

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return (
      <Container className="py-5.5">
        <Alert variant="danger">
          <ErrorPage
            message={intl.formatMessage(messages.errorMessage, {
              supportEmail: getConfig().INFO_EMAIL,
            })}
          />
        </Alert>
      </Container>
    );
  }

  return (
    <>
      <Head title={courseAboutData?.name || ''} />
      <article className="course-about-page">
        <section className="course-about-hero">
          <Container size="xl">
            <div className="course-about-hero__layout">
              <div className="course-about-hero__media course-media-wrapper text-center">
                <CourseAboutCourseMediaSlot courseAboutData={courseAboutData} />
              </div>
              <div className="course-about-hero__content">
                <CourseAboutIntroSlot courseAboutData={courseAboutData} />
              </div>
            </div>
          </Container>
        </section>
        <section className="course-about-content">
          <Container size="xl">
            <div className="course-about-content__layout">
              <div className="course-about-content__main">
                <CourseAboutOverviewSlot
                  overviewData={courseAboutData.overview}
                  courseId={courseId}
                />
              </div>
              <div className="course-about-content__aside">
                <CourseAboutSidebarSlot courseAboutData={courseAboutData} />
              </div>
            </div>
          </Container>
        </section>
      </article>
    </>
  );
};

export default CourseAboutPage;
